export default __webpack_public_path__ + "static/media/desktop.3d9e7eb1.jpg";